import * as React from 'react';
import { memo } from 'react';
import Markdown, { Components } from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import remarkGfm from 'remark-gfm';
import clsx from 'clsx';

type MarkdownRendererProps = {
  children: string;
  className?: string;
};

const components: Partial<Components> = {
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ),
  pre: ({ children }) => <>{children}</>,
};

function MarkdownRendererInner({ children, className }: MarkdownRendererProps) {
  return (
    <div className={clsx('ai-chat-markdown', className)}>
      <Markdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        components={components}>
        {children}
      </Markdown>
    </div>
  );
}

export const MarkdownRenderer = memo(
  MarkdownRendererInner,
  (prev, next) => prev.children === next.children,
);
MarkdownRenderer.displayName = 'MarkdownRenderer';
